// @flow
import React, { Component } from "react";

import type { ErrorsType } from "../../types/UserFormType";
import { StyledTextField, CancelButton, SubmitButton } from "imagus-components";
import { ErrosDisplay, setErrorMsg } from "../../containers/ErrosDisplay";
import { RemoveAllSpace } from "../../../global/functions/MultilLineStrings";

import Grid from "@material-ui/core/Grid";

type AssignLicenceFormStatesType = {
  errors: ErrorsType,
  deviceid: string,
  loading: boolean
};

type AssignLicenceFormPropsType = {
  licenceId: string,
  licenceUuid: string,
  onClose: Function,
  assignDevice: Function
};

const initialform: AssignLicenceFormStatesType = {
  errors: {},
  deviceid: "",
  loading: false
};

class AssignLicenceForm extends Component<AssignLicenceFormPropsType, AssignLicenceFormStatesType> {
  constructor(props: AssignLicenceFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = initialform;
  }

  componentDidMount() {
    this.setState({ ...initialform, errors: {} });
  }

  handleChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState((state: AssignLicenceFormStatesType) => ({
      [name]: value,
      errors: {}
    }));
  }

  submit = (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((): * => ({ "loading": true }));
    const deviceid = RemoveAllSpace(this.state.deviceid);
    this.props.assignDevice(JSON.stringify([deviceid]), this.props.licenceId, this.props.licenceUuid, (): * => this.props.onClose(), this.submitFail);
  }

  submitFail = (errors: ErrorsType): * => {
    this.setState({
      errors: errors,
      loading: false
    });
  }

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;
    return (
      <form onSubmit={(!loading && this.submit) || undefined}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="Device / Host ID"
              name="deviceid"
              value={this.state.deviceid || ""}
              onChange={this.handleChange}
              inpuType="text"
              isInvalid={errors.licence !== undefined}
            />
          </Grid>
          <Grid item xs={12}>
            <ErrosDisplay errors={errors} form="assign device" />
          </Grid>
          <Grid item xs={12}>
            <div className="form-right-btn-block">
              <CancelButton onClick={this.props.onClose} />
              <SubmitButton loading={loading} disabled={Object.keys(errors).length > 0} />
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default AssignLicenceForm;

